import { render, staticRenderFns } from "./CompanyDetailsMessages.vue?vue&type=template&id=0fdba734&scoped=true&"
import script from "./CompanyDetailsMessages.vue?vue&type=script&lang=js&"
export * from "./CompanyDetailsMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdba734",
  null
  
)

export default component.exports